<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Dedication--Front-Matter-"><span class="CharOverride-1">To BRISENA</span></p>
<p class="ORIM-Dedication--Front-Matter-"><span class="CharOverride-1">WHO ACTUALLY WROTE IT</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-1-3.vue?4b0f8daa